module.exports = __webpack_public_path__ + "static/SQUARE-FWT-1ab8882e9cd5890b0e37137df788fe22.gif";